const moment = require("moment-timezone");
const { DATE } = require("../constants");

exports.isValidVoucher = (voucher) => {
  if (voucher.dateUsed) {
    return false;
  }

  const currentDateString = moment().format(DATE.UV_DATE_FORMAT);
  const today = moment(currentDateString, DATE.UV_DATE_FORMAT);

  const fromDate = moment(voucher.validFrom, DATE.UV_DATE_FORMAT);
  const toDate = moment(voucher.validTo, DATE.UV_DATE_FORMAT);

  return today.isBetween(fromDate, toDate, "day", "[]");
};
